import React from 'react';

const ResponsiveContext = React.createContext();

export default ResponsiveContext;
